/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// sections for this page
import SectionText from "pages-sections/blog-post/2019/06/auckland-measurcamp-2019/SectionText.js";
import SectionBlogInfo from "pages-sections/blog-post/2019/06/auckland-measurcamp-2019/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/2019/06/auckland-measurcamp-2019/SectionSimilarStories.js";
import styles from "../../../../pages-sections/services/ServicesSections.module.scss";






// Metadata for this blog post
export const metadata = {
  title: "Auckland Measurecamp 2019 Talk: The Fake Reviews Economy",
  date: "2019-06-17",
  summary: "An in-depth look at the Fake Reviews Economy, discussed at Auckland Measurecamp 2019.",
  image: "/img/posts/2019-06-17-auckland-measurecamp-2019/1.webp",
  url: "https://www.tribalism.com.au/blog-post/2019/06/auckland-measurcamp-2019",
  author: "Scott Sunderland",
};

export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.webp" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="Talk on the Fake Reviews Problem - Measurecamp Auckland 2019 - Tribalism"
        image="/img/posts/2019-06-17-auckland-measurecamp-2019/1.webp"
        url="https://www.tribalism.com.au/blog-post/2019/06/auckland-measurcamp-2019"
        type="article"
        description="We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. In this blog we take a look at the Fake Reviews Economy."

        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/posts/2019-06-17-auckland-measurecamp-2019/1.webp" filter="dark" small>
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <h1 className={classes.title}>
              Auckland Measurecamp 2019 Talk: The Fake Reviews Economy
              </h1>
              <br />
              <Button color="rose" size="lg" href="#start" round>
                <FormatAlignLeft /> Read Article
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <SectionText />
          <SectionBlogInfo />
          <SectionComments />
        </div>
      </div>

      <Footer
        
      />
    </div>
  );
}
